import { useAtomValue } from 'jotai';

import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';
import { DOORS } from '@core/Constants/Filters/DoorsFilter.constants';
import { MultiSelect } from '@plp/Components/MultiSelect/MultiSelect';
import { getOptionsWithAggs } from '@plp/Utils/Filters/GetOptionsWithAggs';
import { useMultiSelectFilters } from '@search-filters/Hooks/UseMultiSelectFilters';

import type { FilterControlBaseProps } from '../../FilterPanel.entity';

import styles from './DoorsFilter.module.css';

type DoorsFilterProps = FilterControlBaseProps;

export const DoorsFilter = ({ strings, isPlpFiltersSeoEnabled, tenant }: DoorsFilterProps) => {
  const { doors } = useAtomValue(aggregationsAtom);
  const { handleSelect, listWithSelected } = useMultiSelectFilters(
    'doors',
    getOptionsWithAggs(DOORS, doors),
    strings,
    isPlpFiltersSeoEnabled,
    tenant,
  );

  return (
    <section className={styles.doorsFilter}>
      <MultiSelect
        groupName="doors"
        classes={{ label: styles.listItem }}
        items={listWithSelected}
        onSelect={handleSelect}
        dataTestId="doors-filter-list"
      />
    </section>
  );
};
